import {Component, OnDestroy, OnInit} from '@angular/core';
import {Upozornenie} from '../model/Upozornenie';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-upozornenia',
    templateUrl: './upozornenia.component.html',
    styleUrls: ['./upozornenia.component.css'],
    standalone: false
})
export class UpozorneniaComponent implements OnInit, OnDestroy {
  public upozornenia: Upozornenie[] = [];
  private upozorneniaSubscription = new Subscription();

  constructor(private appService: AppService) { }

  ngOnInit(): void {
    this.upozorneniaSubscription = this.appService.upozorneniaSubject
      .subscribe((data) => {
        this.upozornenia = data;
      });
    this.upozornenia = this.appService.getUpozornenia();
  }

  ngOnDestroy(): void {
    this.upozorneniaSubscription.unsubscribe();
  }

  closeWarnings() {

  }
}
